import { useId, useRef, useState } from "react";
import { Modal } from "react-bootstrap";

export function removePrompt(name) {
  const label = name || "this item";
  return {
    title: `Remove ${label}?`,
    body: `Are you sure you want to proceed? This removes ${label}.`,
    confirmLabel: "Remove",
  };
}

export function useConfirm() {
  const titleId = useId();
  const bodyId = useId();
  const cancelRef = useRef(null);
  const [pending, setPending] = useState(null);

  const ask = (options) =>
    new Promise((resolve) => {
      setPending({ ...options, resolve });
    });

  const finish = (accepted) => {
    setPending((current) => {
      current?.resolve(accepted);
      return null;
    });
  };

  const dialog = (
    <Modal
      show={Boolean(pending)}
      onHide={() => finish(false)}
      onEntered={() => cancelRef.current?.focus()}
      centered
      className="confirm-dialog"
      aria-labelledby={titleId}
      aria-describedby={bodyId}
    >
      <Modal.Header closeButton>
        <Modal.Title id={titleId}>{pending?.title || "Are you sure?"}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p id={bodyId}>{pending?.body}</p>
      </Modal.Body>
      <Modal.Footer>
        <button ref={cancelRef} type="button" className="confirm-cancel" onClick={() => finish(false)}>
          Cancel
        </button>
        <button type="button" className="confirm-proceed" onClick={() => finish(true)}>
          {pending?.confirmLabel || "Remove"}
        </button>
      </Modal.Footer>
    </Modal>
  );

  return [ask, dialog];
}
